/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifactpackanchorheading3Inputs */

const en_artifactpackanchorheading3 = /** @type {(inputs: Artifactpackanchorheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare with the alternatives`)
};

const pt_artifactpackanchorheading3 = /** @type {(inputs: Artifactpackanchorheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar com as alternativas`)
};

/**
* | output |
* | --- |
* | "Compare with the alternatives" |
*
* @param {Artifactpackanchorheading3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackanchorheading3 = /** @type {((inputs?: Artifactpackanchorheading3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackanchorheading3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackanchorheading3(inputs)
	return pt_artifactpackanchorheading3(inputs)
});
export { artifactpackanchorheading3 as "artifactPackAnchorHeading" }